import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import Settings from '../../../../services/settings.service';
import { Link } from 'react-router-dom';
import { urlFormatter } from '../../../../util';
import Translation from '../../../../services/translation.service';
import postpaidIcon from "../../../../assets/img/icon/Postpaid.svg"
import prepaidIcon from "../../../../assets/img/icon/Prepaid_Plan.svg"
import lebaraNumbersIcon from "../../../../assets/img/icon/Lebara Number.svg"

const TEMPORARY_URL_PREFIX = `${Settings.REACT_APP_API_BASE_URL}images`;

const JoinLebaraMobile = ({
  toggleNavMain,
  toggleNav,
  resetNavList,
  links,
}) => {
  const manageAccountLink =
    urlFormatter(links?.['wsc-dashboard-manage_account']?.['route']) ||
    urlFormatter(links?.['wsc-dashboard-manage_account']?.['1']?.['route']);

  let numberBookingLink = urlFormatter(
    links?.['shop-join_lebara-select_number']?.['route']
  );
  let packgeCategoryLink = urlFormatter(
    links?.['shop-join_lebara-voice_plans']?.['route']
  );
  let bringNumber = urlFormatter(
    links?.['shop-join_lebara-bring_number']?.['route']
  );

  return (
    <li className="nav-list-itm border-bottom mobile-tablet-only">
      <div className="nav-list-lnk pointer" onClick={toggleNavMain}>
        {Translation.key('join_lebara_menu_title')}
      </div>
      <div className="sub-nav-wrapper">
        <div className="sub-nav flex-between">
          <div className="back mobile-tablet-only" onClick={resetNavList}>
            <svg
              width="10"
              height="18"
              viewBox="0 0 10 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 17L1.00016 9.00048L9 1.00048"
                stroke="#7C8095"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>{Translation.key('join_lebara_menu_title')}</span>
          </div>

          <div className="nav-section nav-section-column">
            <h2 className="list-box-title">{Translation.key('start_with_your_plan')}</h2>
            <div className="list-box-container first-container mobile-tablet-only">
              <Link
                className="list-box"
                to={`${packgeCategoryLink}?category=prepaid`}
                onClick={toggleNav}
              >
                <img loading="lazy" src={prepaidIcon} />
                <span>{Translation.key('prepaid_plans')}</span>
              </Link>
              <Link
                className="list-box"
                to={`${packgeCategoryLink}?category=postpaid`}
                onClick={toggleNav}
              >
                <img loading="lazy" src={postpaidIcon} />
                <span>{Translation.key('postpaid_plans')}</span>
              </Link>
            </div>
            <h2 className="list-box-title">{Translation.key('start_with_your_number')}</h2>
            <div className="list-box-container mobile-tablet-only">
              <Link
                className="list-box flex-row"
                to={numberBookingLink}
                onClick={toggleNav}
              >
                <img loading="lazy" src={lebaraNumbersIcon} />
                <span>{Translation.key('lebara_numbers')}</span>
              </Link>
            </div>
            <div className=" list-box-container mobile-tablet-only" style={{marginTop:"10px"}}>
              <Link
                className="list-box flex-row"
                to={bringNumber}
                onClick={toggleNav}
              >
                <img loading="lazy" src={lebaraNumbersIcon} />
                <span>{Translation.key("join_lebara_bring_your_number")}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

const mapStateToProps = (state) => ({
  links: state.layout.routes,
});
export default connect(mapStateToProps)(JoinLebaraMobile);
